export default {
  ALTERATIONS_COUNT_LOADING: '@ALTERATIONS_COUNT_LOADING',
  ALTERATIONS_COUNT_SUCCESS: '@ALTERATIONS_COUNT_SUCCESS',
  ALTERATIONS_COUNT_ERROR: '@ALTERATIONS_COUNT_ERROR',

  ALTERATIONS_ITEMS_LOADING: '@ALTERATIONS_ITEMS_LOADING',
  ALTERATIONS_ITEMS_SUCCESS: '@ALTERATIONS_ITEMS_SUCCESS',
  ALTERATIONS_ITEMS_ERROR: '@ALTERATIONS_ITEMS_ERROR',
  ALTERATIONS_ITEMS_CLEAR: '@ALTERATIONS_ITEMS_CLEAR',

  ALTERATIONS_SEARCH_LOADING: '@ALTERATIONS_SEARCH_LOADING',
  ALTERATIONS_SEARCH_SUCCESS: '@ALTERATIONS_SEARCH_SUCCESS',
  ALTERATIONS_SEARCH_ERROR: '@ALTERATIONS_SEARCH_ERROR',
  ALTERATIONS_SEARCH_CLEAR: '@ALTERATIONS_SEARCH_CLEAR',

  ALTERATIONS_ITEM_DETAILS_LOADING: '@ALTERATIONS_ITEM_DETAILS_LOADING',
  ALTERATIONS_ITEM_DETAILS_SUCCESS: '@ALTERATIONS_ITEM_DETAILS_SUCCESS',
  ALTERATIONS_ITEM_DETAILS_ERROR: '@ALTERATIONS_ITEM_DETAILS_ERROR',
  ALTERATIONS_ITEM_DETAILS_CLEAR: '@ALTERATIONS_ITEM_DETAILS_CLEAR',
};
